import { G } from '@mobily/ts-belt';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { ReferenceField, useGetOne } from 'react-admin';

import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';
import { GetInstrumentOneResponse } from '@Common/types/bo/instruments';

interface Props {
  allocation: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['allocations'][number];
  isLastRow: boolean;
}
export const B2bInvestorProfileShowSicavGridRow: FC<Props> = (props) => {
  const { allocation, isLastRow } = props;

  const { data: instrument } = useGetOne<GetInstrumentOneResponse>(
    'instruments',
    {
      id: allocation.allocation_instruments.at(0)?.instrument_id ?? 0,
    },
    {
      enabled: G.isNotNullable(allocation.allocation_instruments.at(0)?.instrument_id),
    },
  );

  return (
    <Grid
      item
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        borderBottom: '1px #EBEBEB solid',
        padding: '10px 0',
      }}>
      <Grid item xs={4}>
        <span>
          {isLastRow
            ? `> ${allocation.min_years_to_retirement}`
            : allocation.min_years_to_retirement}
        </span>
      </Grid>
      <Grid item xs={8}>
        <ReferenceField
          source="instrument_id"
          record={{ instrument_id: instrument?.id }}
          reference="instruments"
          data-testid="BoExternalB2bInvestorProfileShowSicavGridRow_ReferenceField"
          link="show">
          <span>{instrument?.name}</span>
        </ReferenceField>
      </Grid>
    </Grid>
  );
};
